import type { ReactNode } from "react";
import { Badge, BadgeSize, BadgeVariant } from "shared/components";

export const BetaBadge = ({
  variant,
  className,
  toolTipMessage = "This feature is in beta. We'd love your feedback"
}: {
  variant: BadgeVariant;
  className?: string;
  toolTipMessage?: ReactNode;
}) => {
  return (
    <Badge
      variant={variant}
      size={BadgeSize.SM}
      className={className}
      tooltip={toolTipMessage}
      tooltipClassName="z-50 shadow-xl"
    >
      Beta
    </Badge>
  );
};
